"use client";

import { Component, type ReactNode } from "react";

interface Props {
  fallback?: ReactNode;
  children: ReactNode;
}

interface State {
  errored: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { errored: false };

  static getDerivedStateFromError(): State {
    return { errored: true };
  }

  render() {
    if (this.state.errored) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}
